import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  height: 5rem;
`

const Choice = styled.button`
  background: transparent;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  color: #000;
`

const Pin = styled.div`
  background: ${props => props.active ? `var(--${props.color})` : 'transparent'};
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.75rem 0.75rem 0 0.75rem;
  transform: rotate(45deg);
  position: relative;
  top: ${props => props.mouseDown ? '-10px' : '0'};
  transition: top 0.2s;
`

const Tick = styled.div`
  background: var(--gray);
  margin: 0.5rem 0;
  width: 0.15rem;
  height: 1rem;
`

const Label = styled.div`
  font-size: 1.2rem;
`

const Track = styled.div`
  width: 100%;
  height: 0.3rem;
  position: absolute;
  z-index: 1;
  top: 1.8rem;
  border-radius: 0.25rem;
  background: var(--gray);
`

const Range = styled.input`
  display: block;
  width: 100%;
  position: absolute;
  background: transparent;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  opacity: 0;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 2rem;
    height: 5rem;
  }
`

@observer
export default class Slider extends Component {
  @observable mouseDown = false

  @action
  setMouseDown = () => {
    this.mouseDown = true
  }

  @action
  setMouseUp = () => {
    this.mouseDown = false
  }

  render() {
    const { min, max, labels, value, pinColor, disabled, onChange } = this.props
    const choices = []

    for (let i = min; i <= max; i++) {
      choices.push((
        <Choice key={i}>
          <Pin
            active={i === value}
            color={disabled ? 'gray' : pinColor}
            mouseDown={this.mouseDown}
          />
          <Tick />
          <Label>
            {(labels && labels[i-min]) ? labels[i-min] : i}
          </Label>
        </Choice>
      ))
    }

    return (
      <Box>
        <Track />
        <Range
          type="range"
          step="1"
          min={min.toString()}
          max={max.toString()}
          value={value}
          disabled={disabled}
          onChange={event => onChange(Number.parseInt(event.target.value, 10))}
          onMouseDown={this.setMouseDown}
          onMouseUp={this.setMouseUp}
          onTouchStart={this.setMouseDown}
          onTouchEnd={this.setMouseUp}
        />
        {choices}
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider.js